<template>
  <div>
    <h2 class="subtitle is-3">{{ $t("seasons") }}</h2>
    <router-link v-for="season in league.seasons" :to="`/seasons/${season.id}`" class="is-size-5" :key="season.id">
      <p>{{ season.name }}</p>
    </router-link>
    <br />
    <router-link class="button" :to="`/seasons/new`"> {{ $t("AppMenu.new-season") }}</router-link>
    <router-view></router-view>
  </div>
</template>

<script>
import api from "@/api";
export default {
  components: {},
  data() {
    return {
      league: {},
      isLoading: true,
    };
  },
  created() {
    api.getLeague(this.$route.params.league_id).then(response => {
      this.league = response.data;
      this.isLoading = false;
    });
  },
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss"></style>
